"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailExtendedSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
var detail_schema_1 = require("./detail-schema");
exports.detailExtendedSchema = __assign(__assign({}, detail_schema_1.detailSchema), { allOf: [
        {
            if: {
                properties: {
                    claimTypeCode: {
                        enum: [constants_2.ClaimTypeCode.TitleTransfer, constants_2.ClaimTypeCode.AssignmentOfMortgage],
                    },
                },
            },
            then: {
                required: ['representativeToObtainKey'],
                properties: {
                    representativeToObtainKey: {
                        type: 'object',
                        required: ['fullName', 'phoneNumber'],
                        properties: {
                            fullName: {
                                type: 'string',
                                minLength: 1,
                                maxLength: 35,
                            },
                            phoneNumber: {
                                type: 'string',
                                minLength: 0,
                                maxLength: 10,
                                isNotEmpty: true,
                            },
                        },
                    },
                },
                if: {
                    properties: {
                        representatitiveToObtainKey: {
                            properties: {
                                phoneNumber: {
                                    const: '',
                                },
                            },
                        },
                    },
                },
                else: {
                    properties: {
                        representativeToObtainKey: {
                            properties: {
                                phoneNumber: {
                                    type: 'string',
                                    minLength: 10,
                                    maxLength: 10,
                                },
                            },
                        },
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    claimTypeCode: {
                        const: constants_2.ClaimTypeCode.DeficiencySale,
                    },
                },
            },
            then: {
                required: [
                    'offerAcceptedDate',
                    'propertySoldByTypeCode',
                    'receivedDeficiencySaleCommissionAmount',
                    'receivedDeficiencySalePriceAmount',
                ],
                properties: {
                    receivedDeficiencySalePriceAmount: {
                        type: 'number',
                        maximum: 9999999999999,
                        exclusiveMinimum: 0,
                        decimal: [15, 2],
                        errorMessage: 'should be a decimal greater than 0 with up to 15 digits in total and 2 digits of precision',
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    legalSystemTypeCode: {
                        const: constants_2.LegalSystemType.Other,
                    },
                },
            },
            then: {
                required: ['otherLegalActionTypeDescription'],
                properties: {
                    otherLegalActionTypeDescription: {
                        type: 'string',
                        minLength: 0,
                        maxLength: 60,
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    claimTypeCode: {
                        enum: [constants_2.ClaimTypeCode.EnhancedClaimService, constants_2.ClaimTypeCode.WalkAway],
                    },
                },
            },
            then: {
                required: ['receivedLenderNotificationDate'],
            },
        },
        {
            if: {
                required: ['receivedLenderNotificationDate', 'legalActionStartedDate'],
            },
            then: {
                properties: {
                    receivedLenderNotificationDate: {
                        type: ['string', 'null'],
                        format: 'date',
                        formatExclusiveMinimum: {
                            $data: '1/legalActionStartedDate',
                            customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_RECEIVED_LENDER_NOTIFICATION_LEGAL_ACTION_STARTED_DATE, 'receivedLenderNotificationDate'),
                        },
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    propertyOccupancyStatusCode: {
                        not: {
                            const: constants_2.PropertyOccupancyStatus.Vacant,
                        },
                    },
                },
            },
            else: {
                required: ['propertyVacancyDate'],
            },
        },
        {
            if: {
                properties: {
                    claimTypeCode: {
                        not: {
                            const: constants_2.ClaimTypeCode.WalkAway,
                        },
                    },
                },
            },
            then: {
                required: ['legalActionCompletedDate'],
            },
        },
    ] });
